import React from 'react'
import { FormTextarea } from 'shards-react'

function LongTextInput() {
    return (
        <FormTextarea id="feDescription" rows="5" />
    )
}

export default LongTextInput